"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmModal = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const react_i18next_1 = require("react-i18next");
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
// Make sure Modal knows what DOM element is the app container. Available examples in the package documentation all put this line outside the component.
if (!process.env.IS_TESTING) {
    react_modal_1.default.setAppElement('#app');
}
const ConfirmModal = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['main']);
    const confirm = (e) => {
        // TODO This should always be a function, test before removing, old code may not know
        if (typeof props.confirmAction === 'function') {
            props.confirmAction(e);
        }
        props.closeModal(e);
    };
    const cancel = (e) => {
        // TODO If defined, this should always be a function, test before removing, old code may not know
        if (typeof props.cancelAction === 'function') {
            props.cancelAction(e);
        }
        props.closeModal(e);
    };
    const buttons = props.buttons;
    const buttonsContent = buttons
        ? Object.keys(buttons).map((key) => (react_1.default.createElement("div", { key: key, className: "center" },
            react_1.default.createElement("button", { className: `button ${buttons[key].color || 'blue'}`, onClick: buttons[key].action }, buttons[key].label))))
        : [];
    if (!buttons && props.showCancelButton !== false) {
        buttonsContent.push(react_1.default.createElement("div", { key: 'cancel', className: "center" },
            react_1.default.createElement("button", { type: "button", className: `button ${props.cancelButtonColor || 'grey'}`, onClick: cancel }, props.cancelButtonLabel || t('main:Cancel'))));
    }
    if (!buttons && props.showConfirmButton !== false) {
        buttonsContent.push(react_1.default.createElement("div", { key: 'confirm', className: "center" },
            react_1.default.createElement("button", { type: "button", className: `button ${props.confirmButtonColor || 'blue'}`, onClick: confirm }, props.confirmButtonLabel || t('main:Confirm'))));
    }
    return (react_1.default.createElement(react_modal_1.default, { isOpen: props.isOpen === false ? false : true, onRequestClose: cancel, className: "react-modal", overlayClassName: "react-modal-overlay", contentLabel: props.title },
        react_1.default.createElement("div", null,
            props.title && (react_1.default.createElement("div", { className: "center" },
                react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, props.title))),
            props.children ? (react_1.default.createElement("div", { className: "confirm-popup-content" }, props.children)) : props.text ? (props.containsHtml ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: props.text } })) : (react_1.default.createElement("div", { className: "confirm-popup" },
                react_1.default.createElement(react_markdown_1.default, { remarkPlugins: [[remark_gfm_1.default, { singleTilde: false }]] }, props.text)))) : null,
            react_1.default.createElement("div", { className: 'tr__form-buttons-container _center' }, buttonsContent))));
};
exports.ConfirmModal = ConfirmModal;
exports.default = exports.ConfirmModal;
//# sourceMappingURL=ConfirmModal.js.map